var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.expanded)?_c('section',{staticClass:"mt-2",domProps:{"innerHTML":_vm._s(_vm.formatClaimsData)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }